import React from "react";

const Timetables2 = () => {

  return (
    <>
        {/* <h2>Students' Assignments</h2> */}
        <br />
        
        <ul className="quiz-sub-container">
            <div className="coming-soon">Coming Soon</div>
        </ul>
      </>
  );
};

export default Timetables2;
